export function minifyAuth(auth: any) {
    const { uid, email, displayName: name, emailVerified: activated, isAnonymous, providerData } = auth;

    let isGoogle = false;
    let isFacebook = false;
    let isPassword = false;
    const isLogin = true;
    for (const provider of providerData) {
        switch (provider.providerId) {
            case 'password':
                isPassword = true;
                break;
            case 'google.com':
                isGoogle = true;
                break;
            case 'facebook.com':
                isFacebook = true;
                break;
            default:
                break;
        }
    }

    return {
        uid,
        name,
        email,
        activated,
        isAnonymous,
        isLogin,
        isGoogle,
        isPassword,
        isFacebook,
        providerData,
    };
}
